'use client'

import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import FlashMessage from './FlashMessage'
import { FLASH_MESSAGE_TRANSLATION_PREFIX } from './constants'

const ClientFlashMessage = () => {
  const translate = useTranslate()
  const intl = useIntl()

  const flashMessages = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(intl.messages as Record<string, string>).filter(([key]) =>
          key.startsWith(FLASH_MESSAGE_TRANSLATION_PREFIX),
        ),
      ),
    [intl.messages],
  )

  return <FlashMessage closeLabel={translate('actions.close')} flashMessages={flashMessages} />
}

export default ClientFlashMessage
